<template>
  <div>
    <div v-for="(value, key) in localStorage" :key="key">{{key}}={{value}}</div>
    <button @click="clear">清除</button>
  </div>
</template>

<script>
  export default {
    name: 'clear-storage',
    data () {
      return {
        localStorage: localStorage
      }
    },
    methods: {
      clear() {
        localStorage.clear()
        this.localStorage = localStorage
      }
    },
    mounted() {
    }
  }
</script>

<style lang="less" scoped>

</style>
